import { ActivitySpinnerSize,
  ActivitySpinnerWidget,
  DialogPositioningBehavior,
  DialogType, DialogWidget,
  HorizontalOriginOption,
  TabStyles,
  VerticalOriginOption,
} from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { cssClass } from '../../../style';
import { FieldConceptIndexingErrorCode, FieldConceptIndexingStatusCode } from '../../../ts/ServerApi/requests/GetFieldConceptIndexingStatus';

const cssPrefix = 'DataroleStatusMetadata';
const leftPositionedImage = cssClass(cssPrefix, 'leftPositionedImage', {verticalAlign: 'sub', marginRight: CommonStyles.Sizes.DefaultSpace});
const metadataContainer = cssClass(cssPrefix, 'container', { marginLeft: TabStyles.Spacing.ExtraLargeSpace});
const errorBox =  cssClass(cssPrefix, 'errorBox', {
  color: CommonStyles.Colors.HyperlinkBlue,
  backgroundColor: '#D7ECF9',
  padding: CommonStyles.Sizes.DefaultSpace,
  paddingRight: CommonStyles.Sizes.LargeSpace,
  cursor: 'pointer',
  userSelect: 'none',
  outline: 'none',
});

export const DataRoleStatusMetadata = (fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode, fieldConceptIndexingErrorCode: FieldConceptIndexingErrorCode): JSX.Element | null => {
  const boxRef = React.useRef();
  const [errorTooltipVisible, setErrorTooltipVisible] = React.useState(false);
  switch(fieldConceptIndexingStatusCode){
    case 'INDEXING_FAILED_RETRY_PENDING':
    case 'INDEXING_FAILED':
    case 'INDEXING_UNSUPPORTED':
      /* eslint-disable jsx-a11y/alt-text */
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
      return <span className={metadataContainer}>
          <span className={errorBox}
            ref={boxRef}
            tabIndex={0}
            onClick={() => setErrorTooltipVisible(true)}
            onKeyDown={(e) => {e.key === 'Enter' && setErrorTooltipVisible(!errorTooltipVisible); }}>
            <img src={imgPath('Spaces_Data_Status.svg')} className={leftPositionedImage}/>
            {Messages.dataRoleHeaderMessage_Error()}
          </span>
          {errorTooltipVisible ? <DialogWidget
            title={Messages.dataRoleHeaderMessage_Error()}
            type={DialogType.Uber}
            showCloseButton={false}
            onCloseRequest={() => setErrorTooltipVisible(false)}
            positioningBehavior={DialogPositioningBehavior.Anchored}
            showFooter={false}
            testId={'datarole-status-uber-detail'}
            anchorEl={boxRef.current}
            anchorOrigin={{
              vertical: VerticalOriginOption.top,
              horizontal: HorizontalOriginOption.right,
            }}
            dialogWidth={300}
            handleGlassClick={() => setErrorTooltipVisible(false)}
            isModal
            isGlassTransparent
            disableAutoFocus
            ><ErrorTooltipContent errorCode={fieldConceptIndexingErrorCode}/></DialogWidget> : null}
      </span>;
    case 'INDEXING_IN_PROGRESS':
    case 'INDEXING_PENDING':
    case 'INDEXING_FAILED_RETRY_PENDING':
      return <span className={metadataContainer}>
        <span className={leftPositionedImage}>
          <ActivitySpinnerWidget spinnerSize={ActivitySpinnerSize.Small} testId={'datarole-status'}/>
        </span>
        <span style={{color: '#9B9B9B'}}>
          {Messages.dataRoleHeaderMessage_Loading()}
        </span>
      </span>;
    default:
      return null;
  }
};

/* eslint-disable jsx-a11y/alt-text */
const ErrorTooltipContent = (props: {errorCode: FieldConceptIndexingErrorCode}) => (
  <div>
    <div>
      <span style={{color: CommonStyles.Colors.HyperlinkBlue, padding: CommonStyles.Sizes.DefaultSpace}} >
        <img src={imgPath('Spaces_Data_Status.svg')} className={leftPositionedImage}/>
        {Messages.dataRoleHeaderMessage_Error_NotOperational()}
      </span>
    </div>
    <div style={{padding: CommonStyles.Sizes.DefaultSpace}}>
      {props.errorCode === 'INDEXING_VALUE_LENGTH_EXCEEDED_ERROR' ?
        Messages.dataRoleHeaderMessage_Error_ErrorMessage_SizeExceeded():
        Messages.dataRoleHeaderMessage_Error_ErrorMessage_Default()}
    </div>
  </div>
);
